module.exports = __webpack_public_path__ + "media/images/flags/cg-7d217485b17c6e73ea4f5498fd882ae9.svg";